import React, { useMemo } from "react";

import { UserMinimalFragment } from "../../graphql/fragments";
import {
  AvatarGroup,
  Menu,
  MenuButton,
  MenuLink,
  MenuList,
} from "../wombat-ui";
import Avatar, { AvatarGroupProps } from "../wombat-ui/Avatar";

type UserAvatarGroupProps = {
  users: UserMinimalFragment[];
  max?: number;
};

const UserAvatarGroup: React.FC<UserAvatarGroupProps> = ({ users, max }) => {
  const usersItems = useMemo(
    (): AvatarGroupProps["items"] =>
      users.map((user) => ({
        src: user.avatar,
        name: user.name,
        alt: `${user.name} profile`,
        type: "user",
      })),
    [users]
  );

  return (
    <Menu>
      <MenuButton scale="xs" noIndicator>
        <AvatarGroup items={usersItems} max={max} />
      </MenuButton>
      <MenuList>
        {users.map((user) => {
          return (
            <MenuLink key={user.id} to={`/users/${user.id}`}>
              <div className="flex items-center space-x-4">
                <Avatar
                  size={8}
                  src={user.avatar}
                  alt={`${user.name} profile`}
                  type="user"
                />
                <p className="text-sm font-medium text-dark-100">{user.name}</p>
              </div>
            </MenuLink>
          );
        })}
      </MenuList>
    </Menu>
  );
};

export default React.memo(UserAvatarGroup);
